import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import {
  Row,
  Panel,
  IconButton,
  Icon,
  Modal,
  Button,
  Col,
  ControlLabel,
  RadioGroup,
  Radio,
  Message,
  Input,
  Uploader,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import { isRequired, isValidators, isRequiredFiled } from '../../utils/ValidatorUtils'
import {
  getContractPdf,
  getDownloadContractPdf,
  uploadDocumentsContract,
  getDownloadAttachContractPdf,
} from '../../redux/actions/contract'

import classNames from 'classnames'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isEmpty } from 'lodash-es'
import AppContext from '../../context/AppContext'

export default function AttrachContractFilePanel(props) {
  const { theme } = React.useContext(AppContext)

  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [section, setSection] = useState()
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [showConfirm, setShowConfirm] = useState(false)
  const [contractId, setContractId] = useState('')
  const [isMakeContractError, setIsMakeContractError] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isContartFileError, setIsContartFileError] = useState(false)
  const [isGranteeFileError, setIsGranteeFileError] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [error, setError] = useState(false)
  const [errorMsg, setErrorMsg] = useState()
  const [attachFilePathName, setAttachFilePathName] = useState()
  const [attachFileName, setAttachFileName] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    // let contractId = location.search.substring(1)
    let contractId = sessionStorage.getItem('param')?.substring(1)
    console.log('MakeContractPanel', 'contract_id: ', contractId)
    if (contractId) {
      setContractId(contractId)
    }
  }, [location.search])

  useEffect(() => {
    if (formSchema?.attachment?.value?.path) {
      setAttachFilePathName(formSchema?.attachment?.value?.path)
      setAttachFileName(formSchema?.attachment?.value?.name || ormSchema?.attachment?.value?.label)
    }
  }, [formSchema])

  useEffect(() => {
    //handleGetDownloadContractPdf(projectId)
  }, [projectId])

  const handleGetDownloadContractPdf = async (projectId, pathName) => {
    startLoading()
    setIsLoading(true)
    try {
      const response = await getDownloadAttachContractPdf(projectId, pathName)
      console.log('response preview pdf', response)
      if (response) {
        onDownloadContractPDF(response)
      } else {
        setError('ดาวน์โหลดไม่สำเร็จ no response')
      }
    } catch (e) {
      setError('ดาวน์โหลดไม่สำเร็จ ' + e?.data?.response)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUploadFileContract = async (request) => {
    startLoading()
    setIsLoading(true)
    setError()
    try {
      const response = await uploadDocumentsContract(projectId, request)
      console.log('res ', response)
      if (response) {
        setErrorMsg({ type: 'success', description: 'บันทึกสำเร็จ' })
        setTimeout(() => setErrorMsg(null), 3000)

        if (response[0]) {
          setAttachFilePathName(response[0]?.path)
          setAttachFileName(response[0]?.name || response[0]?.label)
        }
      }
      setError(false)
    } catch (e) {
      setError('อัปโหลดไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)
    const file = data[formSchema.attachment.name]
    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    formData.append('ProjectVersionId', projectId || '')
    formData.append('UserId', '')

    handleUploadFileContract(formData)
  }

  const onClickDownloadAttachContractPDF = () => {
    console.log('formSchema', formSchema)
    console.log('attachFilePathName', attachFilePathName)

    console.log('projectId', projectId)
    setError(false)
    if (attachFilePathName) {
      handleGetDownloadContractPdf(projectId, attachFilePathName)
    } else {
      setError('ไม่พบ pathName')
    }
  }

  const onDownloadContractPDF = async (fileObj) => {
    startLoading()
    try {
      var file = fileObj

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.name || attachFileName || 'เอกสารสัญญา')
      document.body.appendChild(link)
      link.click()
      setIsContartFileError()
    } catch (e) {
      setIsContartFileError('ดาวน์โหลดไม่สำเร็จ')
    }
    doneLoading()
  }

  return (
    <>
      <Panel header={formSchema.panelText2} bordered collapsible defaultExpanded shaded>
        {formSchema?.attachment && (
          <Row>
            <ControlLabel
              className={classNames(isRequired(formSchema.attachment.validators) && 'required')}
            >
              {formSchema.attachment.label}
            </ControlLabel>
            <ErrorMessage error={errors.attachment} />
            <Controller
              name={'attachment'}
              control={control}
              defaultValue={
                !isEmpty(formSchema.attachment.value) ? [formSchema.attachment.value] : undefined
              }
              rules={isValidators(formSchema.attachment.validators)}
              render={(props) => {
                return (
                  <Uploader
                    draggable
                    autoUpload={false}
                    fileList={props.value || []}
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                      } else {
                        let files = []
                        files.push(fileList[fileList.length - 1])
                        props.onChange(files)
                      }
                    }}
                  >
                    <div>
                      <div
                        style={{ lineHeight: '50px' }}
                        className={classNames('uploader', `${theme[0]}-background`)}
                      >
                        <Icon size="4x" icon="upload2" />
                        <small className="uploder__text">
                          <p style={{ wordBreak: 'break-word' }}>
                            คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                          </p>
                        </small>
                      </div>
                    </div>
                  </Uploader>
                )
              }}
            />
          </Row>
        )}

        {error && <Message showIcon type="error" description={error} />}

        {attachFilePathName && (
          <IconButton
            appearance="ghost"
            icon={<Icon icon="download" className="bt-gost-icon-radius"></Icon>}
            onClick={onClickDownloadAttachContractPDF}
          >
            {'ดาวน์โหลดเอกสารที่แนบแล้ว'}
          </IconButton>
        )}

        {showCommandButton && <hr />}

        {isMakeContractError && (
          <Message showIcon type="error" description={formSchema.buttonText + `ไม่สำเร็จ`} />
        )}

        {errorMsg && (
          <Message
            showIcon
            type={errorMsg.type}
            description={errorMsg.description}
            style={{ marginBottom: 20 }}
          />
        )}

        {showCommandButton && (
          <IconButton
            appearance="ghost"
            icon={<Icon icon="save" className="bt-gost-icon-radius"></Icon>}
            onClick={handleSubmit(onSubmit)}
          >
            {formSchema.buttonText2}
          </IconButton>
        )}
      </Panel>
    </>
  )
}
